// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "InventSum"

const create = function () { }

const fields = {
  default: [{
    key: "dataAreaId",
    label: "客户账户",
    sortable: true,
    thStyle: {
      width: "10rem"
    }
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "OnOrder",
    label: "在单",
    sortable: true
  },
  {
    key: "Ordered",
    label: "已订购",
    sortable: true
  },
  {
    key: "AvailOrdered",
    label: "可用合计",
    sortable: true
  },
  {
    key: "AvailPhysical",
    label: "实际库存",
    sortable: true
  },
  {
    key: "PhysicalValue",
    label: "实际成本额",
    sortable: true
  },


  ],
}

const dataForm = {
  id: ""
}

///前端验证
const rules = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create, {}
)
const delete_biz_data = new biz_data_helper.base_entity_helper(
  "delete_InventSumByDataSource", {}, {}
)
const methods = {
  async SaveInventSumExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_InventSum", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(_params, SourceType) {
    let _actions = []
    let group = _.groupBy(_params.mt, "dataAreaId")
    for (var i in group) {
      _actions.push(delete_biz_data.execAction({
        params: {
          SourceType: SourceType,
          DataSource: i
        },
        fields: ["id"]
      }).action({}))
    }
    _.each(_params.mt, t => {
      let _new = _.cloneDeep(t)
      delete _new.id
      _actions.push(
        biz_data
          .insertAction({
            params: _new,
            fields: ["id"]
          })
          .action({
            // output_last_item_map: { id: "id" },
            // output_last_item_when_no_data: { id: -1 },
            // rollback_when: { id: { "=": -1 } }
          })
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })


    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      let _rt = result.data.BatchResult.Actions
      if (
        _rt[_rt.length - 1] &&
        !_.isNull(_rt[_rt.length - 1].Result.Data) &&
        !_.isNull(_rt[_rt.length - 1].Result.Data[0])
      ) {
        return result.data.BatchResult.Actions
      }
      return null
    } else {
      return null
    }
  }
}
export {
  dataForm, fields,
  methods
};

